/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoFusionModelsProductionStatusHistory
 */
export interface MelcoFusionModelsProductionStatusHistory {
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsProductionStatusHistory
     */
    production_status?: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsProductionStatusHistory
     */
    created_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsProductionStatusHistory
     */
    personalization_id?: string | null;
}

export function MelcoFusionModelsProductionStatusHistoryFromJSON(json: any): MelcoFusionModelsProductionStatusHistory {
    return MelcoFusionModelsProductionStatusHistoryFromJSONTyped(json, false);
}

export function MelcoFusionModelsProductionStatusHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsProductionStatusHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'production_status': !exists(json, 'production_status') ? undefined : json['production_status'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'personalization_id': !exists(json, 'personalization_id') ? undefined : json['personalization_id'],
    };
}

export function MelcoFusionModelsProductionStatusHistoryToJSON(value?: MelcoFusionModelsProductionStatusHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'production_status': value.production_status,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'personalization_id': value.personalization_id,
    };
}


